export default "__VITE_ASSET__BqVeZ24X__"